import React from "react";
import classes from "../../pages/terms/style/style.module.css";
import PageName from "../pagename/index";
import { useRouter } from "next/router";
const English = () => {
  const router = useRouter();
  return (
    <div className={`${router.locale === "en" ? "block" : "hidden"}`}>
      <PageName title={"Terms & Conditions"} />
      <div className={classes.container}>
        <div className={classes.margin}>
          <br />
          <p className={classes.bold}>Last updated: April 17th, 2023</p>
          <br />
          <p>
            At Ascot, we are committed to protecting the privacy of our users.
            This Privacy Policy explains how we collect, use, and disclose your
            personal information when you use our company portal. By using our
            portal, you consent to the collection, use, and disclosure of your
            personal information as described in this policy.
          </p>

          <br />
          <p className={classes.bold}> 1. Personal Information We Collect</p>
          <p>
            We may collect personal information from you when you register for
            an account or use our portal, such as:
          </p>
          <br />
          <ul className={classes.disc}>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company name</li>
            <li>Job title</li>
            <li>Location</li>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device information</li>
          </ul>
          <br />
          <p className={classes.bold}>
            2. How We Use Your Personal Information
          </p>
          <p>We may share your personal information with:</p>
          <br />
          <p>- Respond to your inquiries and provide customer support</p>
          <p>
            - Analyze usage of our portal to improve its functionality and user
            experience
          </p>
          <p>
            - Communicate with you about our services, promotions, and events
          </p>
          <p>- Comply with legal obligations</p>
          <br />
          <p className={classes.bold}>
            3. Disclosure of Your Personal Information
          </p>
          <p>We may share your personal information with:</p>
          <br />
          <br />
          <p>- Our affiliates and subsidiaries for business purposes</p>
          <p>
            - Third-party service providers who help us operate our portal and
            provide our services, such as cloud hosting and email marketing
          </p>
          <p>
            -Law enforcement authorities, government agencies, or other third
            parties as required by law
          </p>
          <p className={classes.bold}>4. Data Security</p>
          <p>
            We take reasonable measures to protect your personal information
            from unauthorized access, disclosure, alteration, and destruction.
            However, no data transmission over the internet or storage system
            can be guaranteed to be 100% secure.
          </p>
          <br />
          <p className={classes.bold}>5. Cookies</p>
          <p>
            We use cookies and similar technologies to enhance your user
            experience and personalize your interactions with our portal.
            Cookies are small data files that are placed on your device when you
            visit our portal. You can control the use of cookies through your
            browser settings.
          </p>
          <br />
          <p className={classes.bold}>6. Data Usage</p>
          <p>
            Data Usage is collected automatically. This may include information
            such as Your Device&#39;s Internet Protocol address (e.g. IP
            address), browser type, browser version, the pages of our portal
            that You visit, the time and date of Your visit, the time spent on
            those pages, unique device identifiers and other diagnostic data.
            When You access our portal by or through a mobile device, We may
            collect certain information automatically, including, but not
            limited to, the type of mobile device You use, Your mobile
            device&#39;s unique ID, the IP address of Your mobile device, Your
            mobile operating system, the type of mobile Internet browser You
            use, unique device identifiers and other diagnostic data.
          </p>
          <br />
          <br />
          <p>
            We may also collect information that Your browser sends whenever You
            visit our Service or when You access the Service by or through a
            mobile device.
          </p>
          <br />
          <p className={classes.bold}>7. Retention of Personal Information</p>
          <p>
            We retain your personal information for as long as necessary to
            fulfill the purposes for which it was collected, or as required by
            law. We may also retain certain information for analytical purposes,
            recordkeeping, or to comply with legal obligations.
          </p>
          <br />
          <p className={classes.bold}>8. Childrens Privacy</p>
          <p>
            Our portal is not intended for use by children under the age of 16.
            We do not knowingly collect personal information from children under
            the age of 16. If you are a parent or guardian and believe your
            child has provided us with personal information, please contact us
            using the information provided in the &quot;Contact Us&quot; section
            of this policy.
          </p>
          <br />
          <p className={classes.bold}>9. Third-Party Links</p>
          <p>
            Our portal may contain links to third-party websites or services
            that are not operated or controlled by us. This policy does not
            apply to those third-party websites or services. We are not
            responsible for the privacy practices of those third-party websites
            or services. We encourage you to review the privacy policies of
            those third-party websites or services before providing any personal
            information.
          </p>
          <br />
          <p className={classes.bold}>10. Analytics and Advertising</p>
          <p>
            We may use third-party analytics and advertising tools, such as
            Google Analytics and Google Ads, to analyze how our portal is used
            and to display ads to you on other websites based on your interests.
            These tools may collect information about your activities on our
            portal and other websites over time.
          </p>
          <br />
          <p className={classes.bold}>11. Social Media Features</p>
          <p>
            Our portal may include social media features, such as the Facebook
            Like button and Twitter Share button, etc. These features may
            collect your IP address, which page you are visiting on our portal,
            and may set a cookie to enable the feature to function properly.
            Social media features are either hosted by a third party or hosted
            directly on our portal.
          </p>
          <br />
          <br />
          <p className={classes.bold}>12. Changes to Ownership or Control</p>
          <p>
            In the event that we undergo a merger, acquisition, or sale of all
            or a portion of our assets, your personal information may be among
            the assets transferred or disclosed. We will notify you of any such
            change in ownership or control by posting a notice on our portal or
            by email.
          </p>
          <br />
          <br />

          <p className={classes.bold}>13. Acknowledgment of Acceptance</p>
          <p>
            By using our portal, you acknowledge that you have read and
            understood this Privacy Policy and consent to the collection, use,
            and disclosure of your personal information as described in this
            policy.
          </p>
          <br />
          <br />

          <p className={classes.bold}>14. Governing Law and Jurisdiction</p>
          <p>
            This Privacy Policy is governed by and construed in accordance with
            the laws of Jordan. Any disputes arising under or in connection with
            this policy shall be resolved in the courts of Jordan.
          </p>
          <br />
          <br />

          <p className={classes.bold}>15. Changes to this Privacy Policy</p>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any material changes by posting the updated policy on our
            portal or by email.
          </p>
          <br />
          <br />

          <p className={classes.bold}>16. Contact Us</p>
          <p>
            If you have any questions or concerns about our privacy practices or
            this policy, please contact us at admin@ascot.ws
          </p>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

export default English;
